export const VACANCY_STATUS_MODEL = {
  NEW: 'new',
  IN_PROGRESS: 'selection_in_progress',
  SELECTION_SUSPENDED: 'selection_suspended',
  SELECTION_CANCELLED: 'selection_cancelled',
  SELECTION_COMPLETED: 'selection_completed',
  ARCHIVED: 'archived',
};

export const VACANCY_STATUS_AVAILABLE_OPTIONS = {
  [VACANCY_STATUS_MODEL.NEW]: [
    VACANCY_STATUS_MODEL.NEW,
    VACANCY_STATUS_MODEL.ARCHIVED,
  ],
  [VACANCY_STATUS_MODEL.IN_PROGRESS]: [
    VACANCY_STATUS_MODEL.IN_PROGRESS,
    VACANCY_STATUS_MODEL.SELECTION_SUSPENDED,
    VACANCY_STATUS_MODEL.SELECTION_COMPLETED,
    VACANCY_STATUS_MODEL.SELECTION_CANCELLED,
    VACANCY_STATUS_MODEL.ARCHIVED,
  ],
  [VACANCY_STATUS_MODEL.SELECTION_SUSPENDED]: [
    VACANCY_STATUS_MODEL.SELECTION_SUSPENDED,
    VACANCY_STATUS_MODEL.IN_PROGRESS,
    VACANCY_STATUS_MODEL.ARCHIVED,
  ],
  [VACANCY_STATUS_MODEL.SELECTION_COMPLETED]: [
    VACANCY_STATUS_MODEL.SELECTION_COMPLETED,
    VACANCY_STATUS_MODEL.ARCHIVED,
  ],
  [VACANCY_STATUS_MODEL.SELECTION_CANCELLED]: [
    VACANCY_STATUS_MODEL.SELECTION_CANCELLED,
    VACANCY_STATUS_MODEL.ARCHIVED,
  ],
};
